module.exports = __webpack_public_path__ + "img/46.8431a535.png";